const defaultFilterConfiguration = {
  periodo: 'B',
  comparador: 'A',
  intervalo: 'A'
}

export { defaultFilterConfiguration }
